import { PractitionersTab } from "@/features/settings/components/tabs/practitioners-tab";

/** Standalone Practitioners page (sidebar). The roster header (title, subtitle,
 * actions), role tabs, KPI band and rosters all render from the practitioners
 * panel below, which needs the live roster/member/allocation data for its
 * dynamic header and tab counts. */
export default function PractitionersPage() {
  return <PractitionersTab />;
}
